import {useSelector} from "react-redux";
import GameRoomTab from "./GameRoomTab/GameRoomTab.jsx";
import HistoryRoomTab from "./HistoryRoomTab/HistoryRoomTab.jsx";
import ViewRoomTab from "./ViewRoomTab/ViewRoomTab.jsx";

function DesktopActiveRoomTabItem(props) {
    const {
        id,
        isViewRoom,
        isHistoryRoom,
        isTournamentRoom,
        notifier,
        state,
    } = props;

    const activeRoomId = useSelector(state => state.lobby.activeRoomId);

    const renderComponent = () => {
        if (isHistoryRoom) return (
            <HistoryRoomTab
                roomId={id}
                isActive={Number(activeRoomId) === Number(id)}
            />
        )
        if (isViewRoom && !isHistoryRoom) return (
            <ViewRoomTab
                roomId={id}
                isActive={Number(activeRoomId) === Number(id)}
            />
        )

        return (
            <GameRoomTab
                roomId={id}
                state={state}
                notifier={notifier}
                isActive={Number(activeRoomId) === Number(id)}
                isTournamentRoom={isTournamentRoom}
            />
        )

    };

    return (
        renderComponent()
    )
}

export default DesktopActiveRoomTabItem